<template>
  <b-form-group :label="label">
    <b-form-radio-group
      v-model="selected"
      :options="options"
      :disabled="disabled"
      button-variant="outline-secondary"
      buttons
      stacked
      name="radio-btn-stacked"
      class="w-100"
    ></b-form-radio-group>
  </b-form-group>
</template>

<script>
export default {
  name: "RadioGroup",
  props: {
    options: Array,
    index: Number,
    disabled: Boolean,
    label: String,
    selectedId: Number,
  },
  data() {
    return {
      selected: this.selectedId ? this.selectedId : "",
    };
  },
  watch: {
    selected: function () {
      const selectedAnswer = this.options.find((option) => option.value === this.selected);

      this.$emit("onSelected", this.index, this.selected, selectedAnswer.score);
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .btn-group-vertical {
  .btn-outline-secondary {
    border-radius: 4px !important;
    padding: 16px;
    margin-bottom: 16px;
  }
}
::v-deep .btn-outline-secondary {
  &.disabled {
    &.active {
      background: $color-orange;
      color: $color-white;
    }
  }
}
</style>
